/* 


@PRAKT


   _____________________________________________________________

   |
   | PRODUCT RECOMMANDATIONS
   |
   _____________________________________________________________
*/

/* ______________________________________________________________

   |
   | CLASS
   |
   ______________________________________________________________
*/

export default class ProductRecommendations {
    constructor() {
        this.once = false;
        this.init();
    }

    init() {
        this.section = document.querySelector( '.product-recommendations' );
        if( !this.section ) return;
        this.hideSection();
        this.scrollObserver();
    }

    controlProducts() {
        this.products = this.section.querySelectorAll( '.products-slider__slide' );
        // console.log(this.products);
        // console.log('Related products: ' + this.products.length);
        if( this.products.length == 0 && !this.once ) {
            this.once = true;
            setTimeout( () => {
                this.controlProducts();
            }, 500 );
        } else if ( this.products.length == 0 && this.once ) {
            this.hideSection();
        } else {
            this.showSection();
        }
    }

    hideSection() {
        this.section.style.display = 'block';
        this.section.style.opacity = 0;
        this.section.style.overflow = 'hidden';
        this.section.style.height = 0;
    }

    showSection() {
        this.section.style.opacity = 1;
        this.section.style.overflow = 'auto';
        this.section.style.height = 'auto';
    }

    scrollObserver() {
        const callback = ( entries ) => {
            entries.forEach( ( entry ) => {
                if( entry.isIntersecting ) this.controlProducts();
            } );
        }
        const observer = new IntersectionObserver( callback, { rootMargin: "0px", threshold: 0.05 } );
        observer.observe( this.section );
    }
}